<!--

-->
<template>
  <div>
    <div class="claim-messages-div">
      <!-- Contents list item -->
      <div 
        class="claim-message"
        v-bind:class="{ 'claim-message-admin': !message.isClient, 'claim-message-client': message.isClient}"        
        v-for="message in messages" 
        v-bind:key="message.date">
        <pre class="claim-message-message">
          {{ getMessageText(message) }}
        </pre>
        <div v-if='message.documentId != null'>
          Attached file: <a class="link-text" target='_blank' v-bind:href='message.documentUrl'>{{message.documentName }}</a>
        </div>
        <div class="claim-message-footer">
          {{ getMessageFooter(message) }}
        </div>
      </div>
    </div>  
    <!-- Navigation buttons -->
    <div class="claim-message-button__container">
      <ms-navigation-bar
        :buttons="[backButton]"
        @navigationButtonClick="navigationButtonClick"
      />
    </div>
  </div>
</template>
<script>
  import api from '@/api/api'
  import {ButtonStates, ButtonTypes} from '@/components/app-button'
  import MsNavigationBar, {DefaultNavigationButtons} from '@/components/ms-navigation-bar'
  import { DateTime as LuxonDateTime } from 'luxon'

  export default {
    name: 'ClaimMessagesView',
    components: {
      MsNavigationBar
    },
    data: function () {
      return {
        pagei18nKey: 'message.claimStatus',
        loading: false,
        messages: []
      }
    },
    mounted () {
      this.loading = true

      // see if we have a verifcation code yet?
      let code = this.$store.getters.verificationCode
      if (!code) {
        this.$router.push(`/claim-status/verify/${this.guid}`)
        return
      }
  
      /**
       * Get the chat messages for this claim
       */
      api.getClaimMessages(this.guid, code)
        .then(response => {
          this.loading = false
          let messages = []
          // only include messages with a valid message
          if (response != null) {
            response.forEach(message => {
              if (message.text && message.text.length > 0) messages.push(message)
            })
          }
          this.messages = messages
        })
        .catch(error => {
          console.error(error)
          this.loadingError = true
          this.loading = false
          // check for no auth error
          if (error.response) {
            // TODO update code when server does
            if (error.response.status >= 401 && error.response.status <= 499) {
              // console.log(error.response.status)
              this.$router.push(`/claim-status/verify/${this.guid}`)
            }
          }
        })
    },
    props: {
      guid: String
    },
    /**
     * Check whether we have route props and if they match a given object in
     * item array then set relevant props to pass through to form components
     */
    beforeMount () {
      this.loading = true
    },
    computed: {
      /**
       * Get back button object
       */
      backButton: {
        get () {
          return {
            state: ButtonStates.ENABLED,
            type: ButtonTypes.TERTIARY,
            text: 'message.backButton',
            hasMaxWidth: true,
            id: 'back'
          }
        }
      }
    },
    methods: {
      getMessageText (message) {
        if (message === null) return ''
        return message.text
      },

      getMessageAttachment (message) {
        if (message === null) return ''
        return message.text
      },

      getMessageFooter (message) {
        if (message == null) return ''
        let dateTime = LuxonDateTime.fromISO(message.date)
        if (dateTime.isValid) {
          if (message.isClient) {
            return this.$t(`${this.pagei18nKey}.messageClientPrefix`) + `, ${dateTime.toFormat('dd LLL yyyy, HH:mm')}`
          } else {
            return this.$t(`${this.pagei18nKey}.messageAdminPrefix`) + `, ${dateTime.toFormat('dd LLL yyyy, HH:mm')}`
          }
        } else {
          console.error('could not parse message date')
        }
      },

      /**
       * Change route
       *
       * @param {string} buttonId - Id of buttonk
       */
      navigationButtonClick (buttonId) {
        if (buttonId === DefaultNavigationButtons.BACK.id) {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";
  .claim-messages-div {
    @extend %app_form_container;
  }

  .claim-message {
    padding: $dims-padding-default;
    border: 1px solid #dddddd;
    background: $secondary-brand-color;
    margin-bottom: $dims-spacing-small;
  }

  .claim-message-footer {  
    font-style: italic;
    font-weight: $weight-semibold;
  }

  .claim-message-message {
    white-space: pre-line; 
    background-color: transparent;
    padding: 0;
    word-wrap: break-word;
    font: inherit;
  }

  .claim-message-admin {
    margin-right: $dims-spacing-xlarge;
  }

  .claim-message-client {
    margin-left: $dims-spacing-xlarge;
  }

  .claim-message-button__container {
    background-color: $secondary-brand-color;

    @include mobile {
      padding: 0 $dims-horizontal-gutter;
    }
  }
  .link-text {
    font-weight: $semibold-font-weight;
    color: $quaternary-text-color;
    cursor: pointer;
  }
</style>
